export function realOpciones(product) {
  return (product?.opciones || []).filter((o) => o && o.id);
}

export function needsOpcionPick(product) {
  const ops = realOpciones(product);
  return ops.length >= 2 || (ops.length === 1 && Boolean(String(ops[0].nombre || '').trim()));
}

export function allOpcionesAgotadas(product) {
  const ops = realOpciones(product);
  return ops.length > 0 && ops.every((o) => !o.disponible);
}

export function firstDisponibleOpcion(product) {
  return realOpciones(product).find((o) => o.disponible) || null;
}
